import React, { useEffect } from 'react';
import get from 'lodash/get';
import { observer } from 'mobx-react';
import { Detector } from 'react-detect-offline';

import { AlbumInfo } from './components/AlbumInfo';
import { PlayBar } from './components/PlayBar';
import { ProgressBar } from './components/ProgressBar';
import { DisclaimerLabel } from './components/DisclaimerLabel';

import { SplashScreen } from './components/SplashScreen';

import { OfflineSplashScreen } from './components/OfflineSplashScreen';

import { playBarStore } from './stores/play.bar.store';

import { progressBarStore } from './stores/progress.bar.store';

import { Player } from './core/player';
import { deleteItem } from './core/storage';
import { alive, getSpotsSegments } from './core/player.service';

// import logoBanner from './img/logo-banner.png';
import logoBanner from './img/Logo320.png';

import { clsAPIurl, getTrackingThreshold } from './config';

let player = null;

let intervalId = null;

let bgTimeout = null;

const AppContent = observer(({ online, appStore }) => {
  useEffect(() => {
    appStore.isOnline = online;
    player = new Player({
      appStore,
      progressBarStore,
      playBarStore,
      initialQueueSize: 1
    });
    player.start().then(() => {
      // Started
    });
    intervalId = setInterval(async () => {
      const currentStatus = player.getCurrentStatus();
      // const currentStatus = player.getCurrentStatus();: Se declara una constante llamada currentStatus y se le asigna el valor devuelto por la llamada a la función getCurrentStatus del objeto player. Esto implica que getCurrentStatus es una función de player que devuelve el estado actual del reproductor.
      const playerStateResponse = await alive(currentStatus);

      if (playerStateResponse && playerStateResponse.login_changed === true) {
        // Si playerStateResponse.sessionExpired === false no dibuja la información de la canción y el reproductor se queda atorado.
        // Cierra la sesión del usuario

        // Caducar la sesión del usuario
        localStorage.clear();
      }
    }, getTrackingThreshold());
    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const body = document.getElementById('body-element');
    if (body) {
      if (appStore.currentSong && appStore.currentSong.image && appStore.loadingJukeBox === false) {
        bgTimeout = setTimeout(() => {
          if (appStore.currentSong && appStore.currentSong.image && appStore.loadingJukeBox === false) {
            const src = appStore.currentSong.image;
            const newSrc = `url("${src}")`;
            if (newSrc !== body.style.backgroundImage) {
              body.style.backgroundImage = newSrc;
            }
            clearTimeout(bgTimeout);
            bgTimeout = null;
          }
        }, 400);
      } else {
        body.style.backgroundImage = '';
      }
    }
  }, [appStore, appStore.currentSong, appStore.loadingJukeBox]);

  const handleLogout = () => {
    appStore.forceLogout = true;
    appStore.sessionToken = null;
    appStore.storeName = '';
    deleteItem('APP_TOKEN_SESSION');
    deleteItem('STORE_INFO');
  };

  const renderCurrentTime = () => {
    if (playBarStore.isPlaying === false) {
      return null;
    }
    return <span className='current-time'>{playBarStore.currentTime}</span>;
  };

  const renderPlayerContent = () => {
    if (appStore.offLineState === true) {
      return <OfflineSplashScreen />;
    }
    if (!appStore.isReady || appStore.loadingJukeBox || appStore.errorStarting === true) {
      return (
        <SplashScreen
          errorStarting={appStore.errorStarting}
          onRetry={async () => {
            await player.start();
          }}
        />
      );
    }
    return (
      <>
        <AlbumInfo
          storeName={appStore.storeName}
          songInfo={appStore.currentSong}
          isPlaying={playBarStore.isPlaying}
          waitingForPlay={appStore.waitingForPlay}
          loadingJukeBox={appStore.loadingJukeBox}
        />
        <DisclaimerLabel
          isOnline={appStore.isOnline}
          isSlowConnection={appStore.isSlowConnection}
        />
      </>
    );
  };

  const isSpot = get(appStore, 'currentSong.isSpot', false);

  const overlayClass = appStore.currentSong && !appStore.loadingJukeBox ? ' overlay-bg' : '';

  return (
    <React.Fragment>
      <nav className='navbar navbar-expand-lg navbar-dark primary-color menu'>
        <div className='logo-container'>
          <img src={logoBanner} className='logo-content-small' alt='logo' />
        </div>
        <div className='logout-button' onClick={handleLogout}>
          <i title='Cerrar sesión.' className='fas fa-power-off'></i>
        </div>
      </nav>
      <div id='body-element' className='body'>
        <div
          className={`body-content${overlayClass}`}
        >
          <div className='player-music-content'>{renderPlayerContent()}</div>
        </div>
        <div className='player-bar-menu'>
          <ProgressBar progressBarStore={progressBarStore} />
          <PlayBar
            isSpot={isSpot}
            playButtonIsVisible
            buttonDisabled={!appStore.isReady || appStore.loadingJukeBox}
            playBarStore={playBarStore}
            onPlay={async () => {
              // is a spot and the user click on play
              if (
                !appStore.isReady ||
                appStore.errorStarting === true ||
                isSpot ||
                appStore.waitingForPlay
              ) {
                return;
              }
              playBarStore.isPlaying = await player.play();
              if (appStore.initialStart === false) {
                appStore.initialStart = true;
                getSpotsSegments().then(segments => {
                  // Este código se utiliza para manejar la lógica después de obtener los segmentos mediante la función getSpotsSegments(). El propósito específico de este bloque de código depende de la implementación de getSpotsSegments() y de cómo se utiliza la información de los segmentos en el reproductor (player). Este patrón es común en programación asíncrona para manejar acciones después de la finalización exitosa de operaciones asíncronas.
                  player.addSpotSegments(segments);
                });
              }
            }}
          />

          {renderCurrentTime()}
        </div>
      </div>
    </React.Fragment>
  );
});

export const App = ({ appStore }) => {
  let polling = undefined;

  if (clsAPIurl) {
    polling = {
      url: clsAPIurl
    };
  }

  return (
    <Detector
      polling={polling}
      onChange={status => {
        appStore.isOnline = status;
        if (player) {
          player.queue.isOnline = status;
        }
      }}
      render={({ online }) => (
        <AppContent appStore={appStore} online={online} />
      )}
    />
  );
};
